export const COMMUNITY_COMMENT_INPUT_ID = 'community_comment_input_id';

export const MY_COMMUNITY_MEMBERS = 'My community members';

export const COMMUNITY_SCOPE_OPTIONS = [
  {
    label: 'All Content',
    value: 'all_content',
  },
  {
    label: 'Post',
    value: 'post',
  },
  {
    label: 'Marketplace',
    value: 'marketplace',
  },
  {
    label: 'Recommendation',
    value: 'recommendation',
  },
];

export const COMMUNITY_STATUS_OPTIONS = [
  {
    label: 'Approved',
    value: 'approved',
  },
  {
    label: 'Declined',
    value: 'declined',
  },
  {
    label: 'Auto',
    value: 'auto',
  },
  {
    label: 'Pending posts',
    value: 'pending',
  },
  {
    label: 'Pending posts and comments',
    value: 'all_pending',
  },
];

export const COMMUNITY_POST_TYPES = {
  post: 'post',
  marketplace: 'marketplace',
  recommendation: 'recommendation',
};

export const AVOID_STATUSES = 'declined';

export const COMMUNITY_IMAGES_LIMIT = 4;
